
$(document).on('mouseenter', '.js-play-on-hover-video-with-popup', function() {
	let hoverClass = $(this).attr('data-play-on-hover-class')

	if (hoverClass){
		let hoverEl = $(this).closest(hoverClass)

		if (hoverEl.length){
			let video = hoverEl.find('video')

			if (video.length){

			    video[0].play()

		  	}
		}

	}

})


$(document).on('mouseleave', '.js-play-on-hover-video-with-popup', function() {
	let hoverClass = $(this).attr('data-play-on-hover-class')

	if (hoverClass){
		let hoverEl = $(this).closest(hoverClass)

		if (hoverEl.length){
			let video = hoverEl.find('video')

			if (video.length){

			    video[0].pause()

		  	}
		}

	}

})


$(document).on('click', '.js-play-on-hover-video-with-popup', function() {
	let hoverClass = $(this).attr('data-play-on-hover-class')

	if (hoverClass){
		let hoverEl = $(this).closest(hoverClass)

		if (hoverEl.length){
			let video = hoverEl.find('video')

			if (video.length){
	
			  	video[0].pause()
		  	}
		}

	}

})